import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PageableFilter,
  SubscriptionControllerService
} from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';
import { BusinessUnit } from 'src/app/models';

@Component({
  selector: 'app-editions',
  templateUrl: './editions.component.html',
  styleUrls: ['./editions.component.scss']
})
export class EditionsComponent implements OnInit {
  public subscriberService = inject(SubscriptionControllerService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  businessUnitId: BusinessUnit;
  fixedFilters: Array<PageableFilter> = [];

  columns: Array<TableColumn> = [
    new TableColumn.Builder()
      .setHeader('Tema')
      .setField('editionTheme')
      .setType('text')
      .setRouterLink('')
      .setRouterLinkFieldName('editionDate')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Data de vigência')
      .setField('editionDate')
      .setType('number')
      .setCondition('between')
      .build()
  ];

  ngOnInit(): void {
    this.businessUnitId = this.resolveBusinessUnitId(
      this.activatedRoute.snapshot.queryParamMap.get('businessUnitId')
    );
    this.fixedFilters = [this.businessUnitFilter()];
  }

  openEdition(edition: { editionDate: number }): void {
    this.router.navigate(['/configuracoes/editions/' + edition.editionDate], {
      queryParams: { businessUnitId: this.businessUnitId }
    });
  }

  newEdition(): void {
    this.router.navigate(['/configuracoes/editions/new'], {
      queryParams: { businessUnitId: this.businessUnitId }
    });
  }

  private businessUnitFilter(): PageableFilter {
    return {
      field: 'businessUnitId',
      value: this.businessUnitId,
      condition: 'equals',
      fieldType: 'number'
    };
  }

  private resolveBusinessUnitId(value: string | null): BusinessUnit {
    const parsed = Number(value);
    return parsed === BusinessUnit.Mens
      ? BusinessUnit.Mens
      : BusinessUnit.Glam;
  }
}
